import { SegmentFragment } from '@websky/graphql';

/**
 * Определяет, является ли сегмент код-шеринговым.
 *
 * Код-шеринг означает, что маркетинговый перевозчик (marketingAirline)
 * отличается от фактического (operatingAirline).
 *
 * @param segment - Сегмент рейса.
 * @returns true, если сегмент является код-шеринговым; иначе false.
 *
 */
export const isCodeShared = (segment?: SegmentFragment) => {
	return segment?.operatingAirline?.iata !== segment?.marketingAirline?.iata;
};

/**
 * Проверяет, есть ли среди сегментов хотя бы один код-шеринговый.
 *
 * Проверяет функцией {@link isCodeShared}.
 *
 * @param segments - Массив сегментов.
 * @returns true, если найден хотя бы один код-шеринговый сегмент; иначе false.
 */

export const hasCodeSharedSegments = (segments?: SegmentFragment[]) => {
	return segments?.some(isCodeShared);
};
